define(['app', './index.html'], function (app, tmplPoll) {
  var PollModel = app.Backbone.Model.extend({
    defaults: {
      value: null
    }
  })
  var PollCollection = app.Backbone.Collection.extend({
    model: PollModel
  })
  var PollView = app.Marionette.ItemView.extend({
    template: tmplPoll,

    ui: {
      input: 'input'
    },

    tagName: 'li',

    className: 'poll__item',

    events: {
      'keyup @ui.input': 'checkToAdd',
      'keydown @ui.input': 'checkReturn'
    },

    templateHelpers: function () {
      return {
        input_name: this.options.input_name,
        answers_placeholder: this.options.answers_placeholder
      }
    },

    checkReturn: function (e) {
      if (e.keyCode === 13 && e.currentTarget.value) {
        e.preventDefault()
        e.stopPropagation()
        return this.triggerMethod('return:pressed')
      }
    },

    checkToAdd: function (e) {
      var val = e.currentTarget.value
      var collection = this.model.collection

      if (val) this.model.set('value', val)

      // If last item of the collection is not empty
      if (collection.at(collection.length - 1).get('value')) { collection.add({}) }
    }
  })

  return app.Marionette.CollectionView.extend({
    template: false,

    collection: new PollCollection([{}]),

    childView: PollView,

    childEvents: {
      'return:pressed': 'onFocusLast'
    },

    childViewOptions: function () {
      return {
        input_name: this.options.input_name,
        answers_placeholder: this.options.answers_placeholder
      }
    },

    onFocusLast: function () {
      this.children.findByIndex(this.children.length - 1).ui.input.focus()
    }
  })
})
